import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    auth: {
      authorized: false,
      user: '',
      groupId: null,
      enterpriseId: null,
      personalData: null
    },
    breadcrumb: [],
    videoData: {},
    titleName: {},

    remainPoints: 0,
    playbackRate: 1,
    isOpenSubtitle: true,
    selectedAccent: 'en-EN', // 'en-EN ', 'it-IT', 'en-GB', 'en-AU'
    followData: null,
    level: '初級'
  },
  mutations: {
    isLoading (state, value) {
      state.isLoading = value
    },
    login (state, value) {
      state.auth.authorized = true
      state.auth.user = value
    },
    logout (state, value) {
      state.auth.authorized = false
      state.auth.user = ''
    },
    setVideo (state, value) {
      state.videoData = value.sections.reverse()
      state.titleName = {
        name: value.name,
        name_en: value.name_en
      }
    },
    setBreadcrumb (state, value) {
      state.breadcrumb[0] = value
    },
    setRole (state, value) {
      state.auth.role = value
    },
    setPersonalData (state, value) {
      state.auth.personalData = value
    },
    setEnterpriseId (state, value) {
      state.auth.enterpriseId = value
    },
    setGroupId (state, value) {
      state.auth.groupId = value
    },
    SETPOINTS (state, data) {
      state.remainPoints = data
    },
    SETPLAYBACKRATE (state, value) {
      state.playbackRate = value
    },
    TOGGLESUBTITLE (state, value) {
      state.isOpenSubtitle = value
    },
    SETACCENT (state, value) {
      state.selectedAccent = value
    },
    setFollowData (state, payload) {
      state.followData = payload
    },
    SETLEVEL (state, value) {
      state.level = value
    }
  },
  actions: {
    login: async ({ commit, dispatch }, user) => {
      const fileData = new window.FormData()
      fileData.append('email', user.email)
      fileData.append('password', user.password)
      fileData.append('device_name', 'web')
      const { data } = await api.post('/login', fileData)
      commit('login', data)
      return data
    },
    logout: async ({ commit }) => {
      const { data } = await api.post('/logout')
      commit('logout', data)
    },
    getVideo: async ({ commit, dispatch }, id) => {
      const { data } = await api.get(`/contents/courses/${id}`)
      commit('setVideo', data.data)
    },

    getUser: async ({ commit }) => {
      const { data } = await api.get('/me')
      commit('setRole', data.role)
      commit('setPersonalData', data)
      commit('setEnterpriseId', data.enterprise_id)
      commit('setGroupId', data.group_id)
    },
    getRemainPoints: ({ commit }) => {
      const path = 'ai/generate/all/remain_count'
      const options = { headers: { showLoading: false } }
      api.get(path, options)
        .then(response => {
          if (response && response.data && response.data.default && Number(response.data.default) > -1) {
            commit('SETPOINTS', response.data.default)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    setPlayBackRate: ({ commit }, data) => {
      commit('SETPLAYBACKRATE', data)
    },

    toggleSubtitle: ({ commit }, data) => {
      commit('TOGGLESUBTITLE', data)
    },

    isLoading: ({ commit }, data) => {
      commit('isLoading', data)
    },

    setAccent: ({ commit }, data) => {
      commit('SETACCENT', data)
    },

    saveFollowData ({ commit }, payload) {
      return new Promise((resolve) => {
        localStorage.setItem('followData', JSON.stringify(payload))
        commit('setFollowData', payload)
        resolve()
      })
    },
    clearFollowData ({ commit }) {
      commit('setFollowData', null)
      localStorage.removeItem('followData')
    },
    setLevel: ({ commit }, data) => {
      commit('SETLEVEL', data)
    }
  },
  modules: {
  },
  plugins: [
    createPersistedState(
      {
        key: 'livelearning',
        paths: [
          'auth'

          // 'superAdmin'
        ]
      }
    )
  ],
  getters: {
    isLoading: state => state.isLoading,
    authorized: state => state.auth.authorized,
    videoData: state => state.videoData,
    titleName: state => state.titleName,
    auth: state => state.auth,
    // enterprisesId => state.
    remainPoints: state => state.remainPoints,
    userRole: state => state.auth.userRole,
    isOpenSubtitle: state => state.isOpenSubtitle,
    playbackRate: state => state.playbackRate,
    selectedAccent: state => state.selectedAccent,
    getFollowData: state => {
      if (!state.followData) {
        const saved = localStorage.getItem('followData')
        state.followData = saved ? JSON.parse(saved) : null
      }
      return state.followData
    }
  }
})
